export default "__VITE_ASSET__FwuRVpfh__"